import { ResponseDataObject, ElementHierarchiesDto, ElementMaalingHierarchyDto, ElementPageDto } from '@jobindsats/typescript-fetch-jobindsats';
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';
import { DimensionAccordionElement } from '../shared/ji-accordion-element';
import { DimensionOption } from './model/dimension-option-type';
import { AreaTabOption } from './model/area-tab-option-type';
import { AccordionStatus } from './model/maaling-accordion-status-type';
import { MalingService } from './services/maling-api-service';
import { dimensionStyles } from './styles/dimension-styles';
import { Dimension, Mgroup, DimensionSorting, PeriodData, MeasureMGroupRelation } from './model/response-object-type';

const escoStarKey = '_escostar_rs'

@customElement('maaling-data-element')
export class MaalingDataElement extends JobindsatsElement(LitElement) {
    @property({
        attribute: 'theme-title',
    })
    themeTitle?: string;

    @property({
        attribute: 'maaling-id',
    })
    maalingId?: string;

    @property({ attribute: 'data-title' })
    dataTitle?: string;

    @property({ attribute: 'info-url' })
    infoUrl?: string;

    @property()
    manchet?: string;

    @property({ attribute: 'sharing-url' })
    sharingUrl?: string;

    @property({ attribute: 'export-title' })
    exportTitle?: string;

    cubeId?: string;
    maalingService: MalingService;
    selectedPeriods: string[] = [];
    selectedTab: string = "";
    selectedAreas: string[] = [];
    selectedSubmeasures: string[] = [];
    dimensionSelectMap: Map<string, DimensionOption[]> = new Map();
    hierarchiesNonSelectable: string[] = [];
    JSONdata?: string;

    @state()
    areas?: AreaTabOption[];

    @state()
    errorDialogVisible = false;

    @state()
    metadataMaaling?: ElementPageDto;

    @state()
    footnotes: string[] = [];
    @state()

    accordionStatus: AccordionStatus[] = [];
    memberMeasureSeperator = '-';

    @state()
    dataSource: string[] = [];

    @state()
    tableRows: string[] = [];

    @state()
    tableColumns: string[] = [];

    @state()
    tableVals: string[] = [];

    @state()
    potentialTableColumns: Map<string, string> = new Map();

    @state()
    relatedDimensions: Map<string, string[]> = new Map();

    @state()
    periodDisplaynameAndSort: Map<string, string> = new Map();

    @state()
    dimensionSort: Map<string, string[]> = new Map();

    @state()
    headerKeyNameArray: string[][] = [];

    @state()
    tableDataString?: any;

    @state()
    tableData?: ResponseDataObject;

    @state()
    originalTableData?: string;

    @state()
    transformedData?: any;

    @state()
    pivotControlVisible = false;

    @state()
    exportControlVisible = false;

    @state()
    calcControlVisible = false;

    @state()
    missingFields: string[] = [];

    @state()
    tableSorting: object = {};

    @state()
    busy = false;

    @state()
    dimensionCount: number[] = [];

    @state()
    dialogVisible = false;

    @state()
    dialogItems: string[] = [];

    @state()
    dialogTitle = '';

    @state()
    dialogText = '';

    @state()
    measureMgroupRelationMap: Map<string, MeasureMGroupRelation> = new Map();

    static styles = [
        dimensionStyles, css`
        .datavalg-container {
            position: relative;
        }
        .databank-table-command-list {
            display: flex;
            margin-bottom: 20px;
            flex-wrap: wrap;
        }
        .databank-table-command {
            border: solid;
            border-width: 2px;
            border-color: var(--main-blue);
            background: transparent;
            padding: 12px 0px;
            color: var(--main-blue);
            font-weight: bold;
            cursor: pointer;
            margin-right: 10px;
            margin-top: 10px;
            flex: 1 1 65px;
            max-width: 110px;
        }
        .export-button {
            margin-right: 0;
        }
        .focused {
            background-color: var(--main-blue-10);
        }
        .databank-table-command:hover {
            background-color: var(--main-blue-10);
        }
        .databank-table-command:focus {
            background-color: var(--main-blue-10);
            outline: none;
        }
        .button-container {
            position: absolute;
            height: 100%;
            pointer-events: none;
            right: 0;
            top: 0;
            transform: translateX(60%);
            z-index: 1003;
        }
        .button{
            background-color: var(--main-blue);
            box-shadow: 3px 5px 4px 0px var(--box-shadow-color);
            color: #FFFFFF;
            font-size: inherit;
            position: sticky;
            top: 50%;
            border: none;
            padding: 10px 16px;
            cursor: pointer;
            pointer-events: auto;
        }
        .button:disabled {
            background-color: #90A4AE;
            cursor: wait;
        }
        .close-pivot-button {
            display: flex;
            justify-content: center;
            align-items: center;
            max-width: 45px;
            gap: 5px;
        }
        .close-pivot-button:hover * {
            stroke: var(--main-red);
            fill: var(--main-red);
        }
        .close-pivot-button:focus * {
            stroke: var(--main-red);
            fill: var(--main-red);
            text-color: var(--main-red);
        }
        .close-pivot-container {
            text-align: -webkit-right;
        }
        .dialog-elements-container {
            padding: 0px;
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            list-style-type: disc;
            list-style-position: inside;
        }
        .dialog-item {
            padding-top: 8px;
            display: list-item;
        }
        .button-container-mobile {
            display: none;
        }
        .button-mobile {
            display: none;
        }

        @media only screen and (max-width: 991px) {
            .button, .button-container {
                display: none;
            }
            .button-container-mobile { 
                display: block;
                position: absolute;
                height: 100%;
                pointer-events: none;
                top: 0;
                left: 10%;
                right: 10%;
                z-index: 1003;
            }
            .button-mobile {
                display: block;
                background-color: var(--main-blue);
                box-shadow: 3px 5px 4px 0px var(--box-shadow-color);
                color: #FFFFFF;
                font-size: inherit;
                position: sticky;
                border: none;
                padding: 10px 16px;
                cursor: pointer;
                pointer-events: auto;
                top: 94%;
                width: 100%;
            }
            .button-mobile:disabled {
                background-color: #90A4AE;
            }

            @media screen and (orientation:landscape) {
                .button-mobile {
                    top: 90%;
                }
            }
        }

        #loader {
          position: absolute;
          left: 50%;
          z-index: 1;
          width: 70px;
          height: 70px;
          margin-top: 20px;
          margin-left: -40px;
          border: 16px solid var(--main-blue-10);
          border-radius: 50%;
          border-top: 16px solid var(--main-blue);
          -webkit-animation: spin 0.5s linear infinite;
          animation: spin 0.5s linear infinite;
        }

        @-webkit-keyframes spin {
          0% { -webkit-transform: rotate(0deg); }
          100% { -webkit-transform: rotate(360deg); }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }`
    ];

    constructor() {
        super();
        this.maalingService = new MalingService();
    }

    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('click', this.outsideClickListener);
        const style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(
            document.createTextNode('@import url("/css/pivottable.css"); @import url("/scripts/dist/jobindsats.css")'));
        this.shadowRoot?.appendChild(style);
        this.maalingService.getMetadataMaalingValues({
            maalingId: this.maalingId,
        }).then((res) => {
            this.metadataMaaling = res;
            if (this.metadataMaaling && this.metadataMaaling.maalingHierarchiesContainer) {
                for (let i = 0; i < this.metadataMaaling?.maalingHierarchiesContainer?.length; i++) {
                    if (!this.metadataMaaling.maalingHierarchiesContainer[i].selectable) {
                        this.hierarchiesNonSelectable.push(String(this.metadataMaaling.maalingHierarchiesContainer[i].hierarchyId));
                        //finding all options from non-selectable dimensions 
                        this.dimensionCount.push(JSON.stringify(this.metadataMaaling.maalingHierarchiesContainer[i].hierarchies).split("hrchyId").length - 1);
                    }
                }

                // Removing the hierachies not supposed to be shown to the user
                if (this.hierarchiesNonSelectable.length != 0) {
                    this.metadataMaaling.maalingHierarchiesContainer = this.metadataMaaling.maalingHierarchiesContainer.filter(ar => !this.hierarchiesNonSelectable.find(rm => (rm === ar.hierarchyId)))
                }

                this.areas =
                    this.mapHierarchyToAreaTabOption(this.metadataMaaling.maalingHierarchiesContainer as ElementMaalingHierarchyDto[]);
                this.cubeId = this.metadataMaaling.cubeId ?? 'ukendt cubeId';
                this.selectedTab = this.areas[0].key;
            }
        });
    }

    disconnectedCallback() {
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('click', this.outsideClickListener);
        super.disconnectedCallback();
    }

    render() {
        if (this.metadataMaaling) {
            return html`
            <maaling-header-element title=${this.dataTitle} sharing-url=${this.sharingUrl} info-url=${this.infoUrl} .updateInfo=${this.metadataMaaling.updateInfo}>
                ${this.manchet}
            </maaling-header-element>
            <div class="datavalg-container">
                    <ji-accordion-element nooverflowy="true" title="Vælg data" bold="true" header-background-color="blue" heading-level="2" expand-initially="true">
                        ${this.metadataMaaling ? html`
                            <ji-accordion-element title="Vælg målingsvariable" bold="true" header-background-color="light-blue" 
                                header-background-color="light-blue" heading-level="3" required="true" 
                                ?error=${this.accordionStatus.length && this.accordionStatus[0].error} @accordion-status=${this.handleAccordionClick}>
                                <maaling-selection-element .mGroups=${this.metadataMaaling?.mGroups} 
                                        @submeasure-selected=${(ev: CustomEvent) => { this.handleSubmeasureSelectionUpdated(ev.detail.measures); }}>
                                </maaling-selection-element>
                            </ji-accordion-element>
                            <ji-accordion-element title="Vælg område" bold="true" header-background-color="light-blue" heading-level="3" required="true" ?error=${this.accordionStatus.length && this.accordionStatus[1].error} @accordion-status=${this.handleAccordionClick}>
                                <maaling-area-selection-element
                                    .areas=${this.areas}
                                    @tab-selected=${(ev: CustomEvent) => { this.handleAreaTabSelectionUpdate(ev.detail.areas); }}
                                    @areas-selected=${(ev: CustomEvent) => { this.handleAreaSelectionUpdate(ev.detail.areas); }}>
                                </maaling-area-selection-element>
                            </ji-accordion-element>
                            <ji-accordion-element title="Vælg periode" bold="true" header-background-color="light-blue" heading-level="3" required="true" ?error=${this.accordionStatus[2] && this.accordionStatus[2].error} 
                                    @accordion-status=${this.handleAccordionClick}>
                                <maaling-period-selection-element .periodConfiguration=${this.metadataMaaling?.periodes} 
                                    @period-selected=${(ev: CustomEvent) => { this.handlePeriodSelectionUpdated(ev.detail.periods); }}>
                                </maaling-period-selection-element>
                            </ji-accordion-element>
                            ${this.metadataMaaling?.maalingHierarchiesContainer?.map(hierarchy => {
                if (hierarchy.dimensionId !== '_omrade' && hierarchy.hierarchyId) {
                    const groups = this.dimensionSelectMap.get(hierarchy.hierarchyId) ??
                        hierarchy.hierarchies?.map((hrchy) => this.mapHierarchyToDimensionOption(hrchy));
                    const errorDimension = this.missingFields.includes(`Vælg ${hierarchy.displayName?.toLowerCase() as string}`);
                    return html` <ji-accordion-element title="Vælg ${hierarchy.displayName?.toLowerCase()}" bold="true" header-background-color="light-blue" heading-level="3" ?required=${hierarchy.required} 
                                                ?error=${errorDimension} @accordion-status=${(ev: CustomEvent) => hierarchy.required ? this.handleAccordionClick(ev) : undefined}>
                                                <div class="maaling-container">
                                                    <dimension-manager ?collapsible="${hierarchy.dimensionId === escoStarKey || hierarchy.hierarchyId === escoStarKey}" @options-selected=${(ev: CustomEvent) => {
                            if (hierarchy.hierarchyId && hierarchy.displayName) {
                                this.handleDimensionSelectionUpdate(hierarchy, ev.detail.options);
                            }
                        }} .groups=${groups}>
                                                    </dimension-manager>
                                                </div>
                                            </ji-accordion-element>`;
                }
            })}
                            <div class="button-container"><button @click=${this.handleGetDataButtonClick} id="getDataButton" class="button">Vis resultat</button>
                            </div> `: ''}
                    </ji-accordion-element>
            </div>
            <div class="button-container-mobile"><button @click=${this.handleGetDataButtonClick} id="getDataButtonMobile" class="button-mobile">Vis resultat</button></div>
            <ji-accordion-element id="databankaccordion" title="Vis resultat" bold="true" header-background-color="blue" heading-level="2" borderless="true"
                    @click=${(ev: any) => {
                    if (ev.target) {
                        const target = $(ev.target);
                        if (!ev.path && ev.toElement?.title === 'Vis resultat') { //iOS
                            this.handleGetDataButtonClick('accordion');
                        }
                        else if (target.is('ji-accordion-element') && (ev.composedPath()[1].nodeName === 'BUTTON' || ev.composedPath()[0].nodeName === 'BUTTON')) {
                            this.handleGetDataButtonClick('accordion')
                        }
                    }
                }}>
                <div id="loader"></div>
                <div id="dataContainer">
                    <h1 id="dataTitle">${this.dataTitle}</h1>
                    <div class="databank-table-command-list">
                                <button class="databank-table-command ${this.calcControlVisible ? 'focused' : ''}" @click=${(ev: MouseEvent) => { ev.stopPropagation(); this.showCalcControl(); }} id="calcbutton">
                                    Beregn
                                </button>
                                ${this.calcControlVisible ? html`
                                    <focus-trap>
                                        <ji-callout-element targetSelector=${'calcButton'} @click=${(ev: MouseEvent) => { ev.stopPropagation() }}>
                                            <div class="close-pivot-container">
                                                <a class="close-pivot-button" href="#" @click=${(ev: MouseEvent) => { ev.preventDefault(); this.calcControlVisible = false; }} >
                                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#003087"/>
                                                    </svg>
                                                Luk</a>
                                            </div>
                                            <maaling-calculate-element
                                                .rows=${this.tableRows} 
                                                .columns=${this.tableColumns} 
                                                .relatedDimensions=${this.relatedDimensions}
                                                .headerArray=${this.headerKeyNameArray}
                                                .dataString=${this.tableDataString}
                                                .jsonData=${this.JSONdata}
                                                .indexArray=${this.transformedData[0]}
                                                .dimensionSort=${this.dimensionSort}
                                                .periodDisplaynameAndSort=${this.periodDisplaynameAndSort}
                                                @calc-done=${(ev: CustomEvent) => { this.handleCalcDone(ev.detail.json, ev.detail.periodSort, ev.detail.dimensionSort); }}>
                                            </maaling-calculate-element>
                                        </ji-callout-element>
                                    </focus-trap>` : ''}
                                <button class="databank-table-command ${this.pivotControlVisible ? 'focused' : ''}" @click=${(ev: MouseEvent) => { ev.stopPropagation(); this.showPivotControl(); }} id="pivotbutton">
                                    <div>Pivotér</div>
                                </button>
                                ${this.pivotControlVisible ? html`
                                    <focus-trap>
                                        <ji-callout-element pivotBtn=${true} targetSelector=${'pivotButton'} @click=${(ev: MouseEvent) => { ev.stopPropagation() }}>
                                        <div class="close-pivot-container">
                                            <a class="close-pivot-button" href="#!" role="button" @click=${(ev: MouseEvent) => { ev.preventDefault(); this.pivotControlVisible = false; }} >
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#003087"/>
                                                </svg>
                                            Luk</a>
                                        </div>
                                        <maaling-pivot-element .rows=${this.tableRows} .columns=${this.tableColumns} .relatedDimensions=${this.relatedDimensions} @pivoted=${(ev: CustomEvent) => this.handlePivot(ev)}></maaling-pivot-element>
                                        </ji-callout-element>
                                    </focus-trap>` : ''}
                            <button class="databank-table-command export-button ${this.exportControlVisible ? 'focused' : ''}" @click=${(ev: MouseEvent) => { ev.stopPropagation(); this.showExportControl(); }} id="exportbutton">
                                <div>Eksportér</div>
                            </button>
                            ${this.exportControlVisible ? html`
                                <focus-trap>
                                    <ji-callout-element exportBtn=${true} targetSelector=${'exportButton'} @click=${(ev: MouseEvent) => { ev.stopPropagation() }}>
                                    <div class="close-pivot-container">
                                        <a class="close-pivot-button" href="#!" role="button" @click=${(ev: MouseEvent) => { ev.preventDefault(); this.exportControlVisible = false; }} >
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#003087"/>
                                            </svg>
                                        Luk</a>
                                    </div>
                                        <maaling-export-element
                                            .table=${this.shadowRoot?.getElementById('databanktable')?.querySelector('table.pvtTable')}
                                            .header=${this.shadowRoot?.getElementById('dataTitle')?.innerText}
                                            .source=${this.shadowRoot?.getElementById('data-source')?.innerText}
                                            .footer=${this.shadowRoot?.getElementById('footnotes')?.innerText}
                                            .exportJsonData=${this.JSONdata}
                                            .maalingId=${this.maalingId}
                                            .themeTitle=${this.themeTitle}
                                            .exportTitle=${this.exportTitle}>
                                        </maaling-export-element>
                                    </ji-callout-element>
                                </focus-trap>`: ''}
                    </div>
                    <div id="databanktable" class="thin-scrollbar"></div>
                    <p class="data-source-container" id="data-source">
                        <strong>Kilde:</strong> ${this.dataSource.length ? this.dataSource : 'Ingen kilde angivet'}
                    </p>
                    <p class="footnote-container" id="footnotes">
                        <strong>Anm.:</strong> ${this.footnotes.length ? this.footnotes : 'Ingen fodnote angivet​'}
                    </p>
                </div>
            </ji-accordion-element>
            <div id="loader-margin"></div>
            <ji-dialog-element .visible=${this.errorDialogVisible} @closeDialog=${() => this.hideErrorDialog()} .title=${'Udfyld påkrævede felter'}>
                    <p>Følgende felter mangler udfyldning: </p>
                    <ul class="dialog-elements-container">
                        ${this.missingFields.map(field => {
                    return html`
                                    <li class="dialog-item">${field}</li>
                            `;
                })}
                    </ul>
            </ji-dialog-element>
             <ji-dialog-element .visible=${this.dialogVisible} @closeDialog=${() => this.dialogVisible = false} .title=${this.dialogTitle}>
                    <p>${this.dialogText}</p>
                    <ul class="dialog-elements-container">
                        ${this.dialogItems.map(field => {
                    return html`
                                    <li class="dialog-item">${field}</li>
                            `;
                })}
                    </ul>
            </ji-dialog-element>
        `;
        };
    }

    handleKeydown = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            this.hideCallouts();
        }
    };

    outsideClickListener = (e: MouseEvent) => {
        this.hideCallouts();
    };

    hideCallouts() {
        if (this.pivotControlVisible) {
            this.pivotControlVisible = false;
        }
        if (this.exportControlVisible) {
            this.exportControlVisible = false;
        }
        if (this.calcControlVisible) {
            this.calcControlVisible = false;
        }
    }

    showPivotControl() {
        this.exportControlVisible = false;
        this.calcControlVisible = false;
        this.pivotControlVisible = !this.pivotControlVisible;
    }

    showExportControl() {
        this.calcControlVisible = false;
        this.pivotControlVisible = false;
        this.exportControlVisible = !this.exportControlVisible;
    }

    showCalcControl() {
        this.exportControlVisible = false;
        this.pivotControlVisible = false;
        this.calcControlVisible = !this.calcControlVisible;
    }

    handlePivot(ev: CustomEvent) {
        this.pivotControlVisible = false;
        this.tableRows = ev.detail.rows;
        this.tableColumns = ev.detail.columns;
        if (this.tableData) {
            this.renderTable(this.tableData, true);
        }
    }

    showFootnotes() {
        let footnotes: (string | null)[] = [];
        let dataSource: string[] | null = null;
        if (this.metadataMaaling) {

            footnotes.push(this.metadataMaaling.footnote ?? null);

            if (this.metadataMaaling.mGroups) {
                footnotes = footnotes.concat(this.metadataMaaling.mGroups.map(
                    mGroup => mGroup.footnote && mGroup.mgroupID && this.selectedSubmeasures.includes(mGroup.mgroupID)
                        ? mGroup.footnote
                        : null));
            }

            if (this.metadataMaaling.maalingHierarchiesContainer) {
                const selectedDims = Array.from(this.dimensionSelectMap.keys());
                footnotes = footnotes.concat(
                    this.metadataMaaling.maalingHierarchiesContainer.map(
                        maalingHierarchy => maalingHierarchy.footnote &&
                            maalingHierarchy.dimensionId &&
                            selectedDims.includes(maalingHierarchy.dimensionId)
                            ? maalingHierarchy.footnote
                            : null));
            }

            if (this.metadataMaaling.dataSourceTexts) {
                dataSource = this.metadataMaaling.dataSourceTexts.map(a => a.trim());
            }

            footnotes = footnotes.filter(Boolean).map(a => (a as string).trim());
        }


        const dataSourceElement = this.shadowRoot?.getElementById('data-source');
        if (dataSourceElement) {
            if (dataSource) {
                dataSourceElement.innerHTML = `<b>Kilde: </b>${dataSource.join(', ')}`;
            }
        }

        const footnoteElement = this.shadowRoot?.getElementById('footnotes');
        if (footnoteElement && footnotes.length) {
            footnoteElement.innerHTML = `<b>Anm.: </b>${footnotes.join(' ')}`;
        }
    }

    renderTable(data: ResponseDataObject, pivot?: boolean) {

        if (pivot) {
            this.callPivotUI(this.transformedData);
        } else {
            this.tableData = data;
            this.transformedData = this.refactorResponseObject(data.header, data.data);
            this.callPivotUI(this.transformedData);
        }
    }

    callPivotUI(inputData: any[]) {
        const tableElement = this.shadowRoot?.getElementById('databanktable');
        if (tableElement && this.shadowRoot) {
            const tableObserver = new MutationObserver(() => {
                const databankTable =
                    this.shadowRoot?.getElementById('databanktable')?.querySelector('table.pvtTable');
                if (databankTable && this.shadowRoot) {
                    const topOfElement =
                        (this.shadowRoot?.getElementById('databankaccordion') as HTMLElement).offsetTop + 25;
                    window.scroll({ top: topOfElement, behavior: 'smooth' });
                    tableObserver.disconnect();
                }
            });
            tableObserver.observe(tableElement,
                {
                    childList: true,
                    subtree: true,
                }
            );
        }

        if (this.shadowRoot) {

            //// check if table was already pivoted. If it is, then set the table rows and columns
            //let path = window.location.pathname;

            //while (path.startsWith('/')) {
            //    path = path.slice(1);
            //}

            //while (path.length > 1 && path.endsWith('/')) {
            //    path = path.slice(0, -1);
            //}

            //const colKey = path + "_transformedCol";
            //const rowKey = path + "_transformedRow";

            //if (localStorage.getItem(colKey) !== null && localStorage.getItem(rowKey) !== null) {
            //    const transformedColumns = JSON.parse(localStorage.getItem(colKey) ?? '[]');
            //    const transformedRows = JSON.parse(localStorage.getItem(rowKey) ?? '[]');

            //    this.tableColumns = transformedColumns;
            //    this.tableRows = transformedRows;
            //}

            $(this.shadowRoot).find('#databanktable').pivotUI(
                inputData,
                {
                    cols: this.tableColumns,
                    rows: this.tableRows,
                    vals: ['Målingsværdi'],
                    sorters: this.tableSorting,
                    onRefresh: () => this.hideAnimation(),
                    rendererOptions: {
                        table: {
                            colTotals: false,
                            rowTotals: false,
                        },
                    },
                    showUI: false,
                    aggregatorName: 'Liste unikke værdier',
                }, true, 'da'
            );
        }
    }

    refactorResponseObject(header: any, data: any) {

        let transformedData: any = data;

        let headerKeys: string[],
            headerDisplayNames: string[],
            dimensions: Dimension,
            mgroups: Mgroup,
            dimSort: DimensionSorting,
            periodData: PeriodData;

        [headerKeys, headerDisplayNames, dimensions, mgroups, dimSort, periodData] = header;

        this.headerKeyNameArray = [[...headerKeys], [...headerDisplayNames]];
        this.tableDataString = JSON.stringify(data);

        let hasMgroups = false;
        this.dimensionSort = new Map();
        let measureMgroupRelationMap: Map<string, MeasureMGroupRelation> = new Map();

        this.relatedDimensions.clear();
        this.periodDisplaynameAndSort.clear();

        periodData.period.forEach(
            period => this.periodDisplaynameAndSort.set(period.periode.trim(), period.display_name));

        let dimHrchy = new Map<string, string[]>();

        dimSort.valueset.forEach(dim => {
            const index = headerKeys.findIndex(key => key === dim.dimension_id);
            dimHrchy.set(headerDisplayNames[index], dim.hierarchy_value.map(a => a.hrchy_id));
        });

        var areaSortOrder = dimSort.valueset.find(a => a.dimension_id === '_omrade_txt');

        if (areaSortOrder) {
            this.dimensionSort.set('Område', areaSortOrder.hierarchy_value.flatMap(a => a.hrchy_txt));
        }

        for (let dim of dimensions.dimension) {
            const dimensionLevels = dim.levels;
            const dimensionDisplayName = dim.display_name;

            this.relatedDimensions.set(dimensionDisplayName, dimensionLevels);

            transformedData = this.removeDimensionIdAndReplaceNullInLevels(dimensionDisplayName,
                dimensionLevels,
                headerKeys,
                headerDisplayNames,
                transformedData);

            var dimSortOrder = dimSort.valueset.find(a => a.dimension_id === dim.dimension_id);

            dim.levels.forEach(level => {
                if (dimSortOrder) {
                    this.dimensionSort.set(level.trim(),
                        dimSortOrder.hierarchy_value.flatMap(a => a.hrchy_txt));
                }
            });
        }

        // populating measureMgroupRelationMap used for sorting
        var count = 1;
        for (let mgroup of mgroups.mgroup) {
            for (let i = 0; i < mgroup.measure.length; i++) {
                let measure = mgroup.measure[i];
                measureMgroupRelationMap.set(
                    measure.meas_memb_id,
                    {
                        measure_name: measure.display_name,
                        mgroup_name: mgroup.mgrp_display_name === measure.display_name ? ' '.repeat(count) : mgroup.mgrp_display_name, // spacing added to enable sorting for equal display_names
                        mgroup_order: mgroup.mgrp_display_order,
                        measure_order: measure.display_order,
                    });
            }
            count += 1;

            if (mgroup.measure.length > 1) {
                hasMgroups = true;
            }
        }

        transformedData =
            this.oneMeasureForEachArray(headerDisplayNames, transformedData, hasMgroups, measureMgroupRelationMap, mgroups.mgroup);

        this.measureMgroupRelationMap = measureMgroupRelationMap;
        this.tableSorting = this.getSortingsForTable(this.dimensionSort, measureMgroupRelationMap);


        this.tableVals = ['Målingsværdi'];
        this.tableColumns = ['Målingsvariable'];
        this.tableRows = [];


        dimHrchy.forEach((hrchy, dim) => {
            const hrchyLevel = hrchy.map(a => a.split("/").length - 2); // minus 2 due to split.length counting 1 too much and due to "/" being level 0
            let hrchyMaxDepth = Math.max(...hrchyLevel);
            hrchyMaxDepth = hrchyMaxDepth ? hrchyMaxDepth : hrchyMaxDepth + 1; // if max depth is 0 it should be 1 as one column is needed to show data no matter the level

            if (this.relatedDimensions.has(dim)) {
                const dimKeysNeeded = (this.relatedDimensions.get(dim) as string[]).slice(0, hrchyMaxDepth);
                this.relatedDimensions.set(dim, dimKeysNeeded);

                if (dimKeysNeeded.length === 1 && hrchy.length === 1) {
                    this.tableColumns.unshift(dim);
                } else {
                    this.tableRows.push(dim);
                }
            } else
                return;

        });


        if ((dimHrchy.get('Område') as string[]).length === 1) {
            this.tableColumns.unshift('Område');
        } else {
            this.tableRows.unshift('Område');
        }

        if (this.periodDisplaynameAndSort.size === 1 && this.tableRows.length !== 0) {
            this.tableColumns.unshift('Periode');
        } else {
            this.tableRows.unshift('Periode');
        }

        this.relatedDimensions.set('Målingsvariable', ['Mgroup', 'Måling']);

        this.tableRows =
            this.tableRows.flatMap((a: any) => this.relatedDimensions.has(a)
                ? [a, ...this.relatedDimensions.get(a) as string[]]
                : a);
        this.tableColumns =
            this.tableColumns.flatMap((a: any) => this.relatedDimensions.has(a)
                ? [a, ...this.relatedDimensions.get(a) as string[]]
                : a);

        if (this.tableRows.length === 0) {
            const periodIndex = this.tableColumns.findIndex(col => col === 'Periode');
            this.tableColumns.splice(periodIndex, 1);
            this.tableRows.push('Periode');
        }

        if (transformedData !== null) {
            this.JSONdata = JSON.stringify(transformedData);
            return [headerDisplayNames, ...transformedData];
        } else {
            return [];
        }
    }

    // Adding sorting functions that is used for sorting the table colums+rows.
    getSortingsForTable(dimensionSort: Map<string, string[]>, measureMgroupRelationMap: Map<string, MeasureMGroupRelation>) {
        const sortedMeasures = Array.from(measureMgroupRelationMap.values())
            .sort(this.compareGroupRelation)
            .map(relation => relation.measure_name);
        const sortedMGroups = Array.from(measureMgroupRelationMap.values())
            .sort(this.compareGroupRelation)
            .map(relation => relation.mgroup_name);

        const sortedPeriods = Array.from(this.periodDisplaynameAndSort.values());

        dimensionSort.forEach((value, key) =>
            this.tableSorting = { ... this.tableSorting, ...{ [key]: $.pivotUtilities.sortAs(value) } }
        );

        return {
            ...this.tableSorting,
            ...{ 'Måling': $.pivotUtilities.sortAs(sortedMeasures) },
            ...{ 'Mgroup': $.pivotUtilities.sortAs(sortedMGroups) },
            ...{ 'Periode': $.pivotUtilities.sortAs(sortedPeriods) },

        };
    }

    // sort by mgroup_order, then by measure_order (asc)
    compareGroupRelation(a: MeasureMGroupRelation, b: MeasureMGroupRelation): number {
        if (a.mgroup_order < b.mgroup_order) {
            return -1;
        }
        if (a.mgroup_order > b.mgroup_order) {
            return 1;
        }
        if (a.measure_order < b.measure_order) {
            return -1;
        }
        if (a.measure_order > b.measure_order) {
            return 1;
        }
        return 0;
    }

    flatten(array: any[]): any[] {
        return array.flatMap((item) => {
            return Array.isArray(item.measure) ? this.flatten(item.measure) : item;
        });
    }

    oneMeasureForEachArray(headerDisplayNames: string[],
        transformedData: any,
        hasMgroups: boolean,
        measureMgroupRelationMap: Map<string, MeasureMGroupRelation>,
        measures: any[]) {
        const mGroupMemberCount = Array.from(measureMgroupRelationMap.values()).length;
        const firstMeasureName = headerDisplayNames[headerDisplayNames.length - mGroupMemberCount];
        const firstMeasureIndex =
            headerDisplayNames.findIndex((headerDisplayName: string) => headerDisplayName === firstMeasureName);
        let measuresList = this.flatten(measures);


        const transpose = (a: any) => a[0].map((_: any, c: string | number) => a.map((r: any) => r[c]));
        const decimalCounts = transformedData.map((a: any) => a.slice(firstMeasureIndex).flatMap((b: Array<number | null>) => b?.toString().split('.')[1] ? b.toString().split('.')[1].length : 0));
        const fractionDigits = transpose(decimalCounts).map((a: number[]) => Math.max(...a));

        hasMgroups ? headerDisplayNames.push('Målingsværdi', 'Mgroup', 'Måling') : headerDisplayNames.push('Målingsværdi', 'Måling');
        const dataSplitOnMeasures = transformedData.flatMap((row: any) => {
            const measureVals = row.slice(firstMeasureIndex, firstMeasureIndex + mGroupMemberCount);
            row.splice(0, 1, this.periodDisplaynameAndSort.get(row[0].trim() as string) ?? row[0]);
            row.forEach((rowEntry: any, innerIdx: number) => typeof rowEntry === 'string'
                ? row.splice(innerIdx, 1, rowEntry.trim())
                : rowEntry);
            return measureVals.map((measureVal: number | null, index: number) => {
                var newRow = [...row];
                newRow.splice(firstMeasureIndex,
                    mGroupMemberCount,
                    measureVal?.toLocaleString('da-DK', { minimumFractionDigits: fractionDigits[index] }) ?? '.');
                var measMemberId = measuresList[index].meas_memb_id;
                var relation: MeasureMGroupRelation = measureMgroupRelationMap.get(measMemberId)!;
                hasMgroups && relation ? newRow.push(relation.mgroup_name, relation.measure_name) : newRow.push(relation.measure_name);
                return newRow;
            });
        });

        headerDisplayNames.splice(firstMeasureIndex, mGroupMemberCount);

        return dataSplitOnMeasures;
    }

    removeDimensionIdAndReplaceNullInLevels(dimensionName: string,
        dimensionLevels: string[],
        headerKeys: string[],
        headerDisplayNames: string[],
        data: any) {
        const index = headerDisplayNames.findIndex(display => display === dimensionName);
        if (index !== -1) {
            headerDisplayNames.splice(index, dimensionLevels.length + 1, ...dimensionLevels);
            headerKeys.splice(index, dimensionLevels.length + 1, ...dimensionLevels);

            data.forEach((row: (string | null)[]) => {
                let dimensionVals = row.slice(index, index + dimensionLevels.length + 1);
                const newVal = dimensionVals.shift();
                if (newVal) {
                    dimensionVals = dimensionVals.map((a) => a ? a : newVal);
                    row.splice(index, dimensionLevels.length + 1, ...dimensionVals);
                }
            });
        }

        return data;
    }

    showErrorDialog() {
        this.errorDialogVisible = true;
    }

    hideErrorDialog() {
        this.errorDialogVisible = false;

        for (let i = 0; i < this.accordionStatus.length; i++) {
            if (!this.accordionStatus[i].expanded) {
                this.clickOnAccordion(this.accordionStatus[i].id);
            }
        }
        this.scrollToElement();
    }

    clickOnAccordion(id: string) {
        const errorContainers = this.shadowRoot?.querySelectorAll('[error]');
        if (errorContainers) {
            for (let i = 0; i < errorContainers?.length; i++) {
                if (errorContainers[i].id === id) {
                    errorContainers[i].shadowRoot?.querySelector('button')?.click();
                }
            }
        }
    }

    scrollToElement() {
        //this.shadowRoot?.querySelector('[error]')?.scrollIntoView({ behavior: 'smooth',  block: 'center', });
        const topOfElement = (this.shadowRoot?.querySelector('[error]') as HTMLElement).offsetTop + 237;
        window.scroll({ top: topOfElement, behavior: 'smooth' });
    }

    /**
     * Is only triggered if minimized accordion is marked as required 
     */
    handleAccordionClick(ev: CustomEvent) {
        const index = this.accordionStatus.findIndex(a => a.id === ev.detail.id);
        if (index !== -1) {
            this.accordionStatus[index].expanded = ev.detail.expanded;

            const isRequiredDimension =
                this.metadataMaaling?.maalingHierarchiesContainer?.filter(
                    maalingHierarch => maalingHierarch.required &&
                        maalingHierarch.dimensionId === this.accordionStatus[index].id);

            const dimensionSelections = Array.from(this.dimensionSelectMap.keys());
            const missingAccordions = this.findMissingFields(dimensionSelections);
            if (missingAccordions.includes(this.accordionStatus[index].title) && isRequiredDimension) {
                this.accordionStatus[index].error = true;
                if (!this.missingFields.includes(this.accordionStatus[index].title)) {
                    this.missingFields.push(this.accordionStatus[index].title);
                }
                this.requestUpdate();
            }
        } else {
            this.accordionStatus?.push({
                id: ev.detail.id,
                title: ev.detail.title,
                expanded: ev.detail.expanded,
                error: false
            });
        }
    }

    handleGetDataButtonClick(caller?: string) {
        if (!this.busy) {

            const dataaccordion = (this.shadowRoot?.getElementById('databankaccordion') as HTMLElement |
                (HTMLElement & DimensionAccordionElement) |
                null);

            const dimensionSelections = Array.from(this.dimensionSelectMap.keys());

            for (let i = 0; i < this.hierarchiesNonSelectable.length; i++) {
                dimensionSelections.push(this.hierarchiesNonSelectable[i]);
            }

            if (this.missingRequiredSelections(dimensionSelections)) {

                this.showErrorDialog();

                if (caller === 'accordion') {
                    if (dataaccordion && 'toggleAccordion' in dataaccordion && dataaccordion.expanded) {
                        dataaccordion.toggleAccordion();
                    }
                }
            } else {

                if (dataaccordion && 'toggleAccordion' in dataaccordion && !dataaccordion.expanded) {
                    dataaccordion.toggleAccordion();
                }
                this.shadowRoot?.getElementById('databankaccordion')?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                this.getData(dimensionSelections);
            }
        }
    }

    hideAnimation() {
        const getDataButton = this.shadowRoot?.getElementById('getDataButton') as HTMLButtonElement;
        const getDataButtonMobile = this.shadowRoot?.getElementById('getDataButtonMobile') as HTMLButtonElement;
        const dataContainer = this.shadowRoot?.getElementById('dataContainer') as HTMLElement;
        const loader = this.shadowRoot?.getElementById('loader') as HTMLElement;
        const loaderMargin = this.shadowRoot?.getElementById('loader-margin') as HTMLElement;

        loaderMargin.style.marginBottom = '0';
        dataContainer.style.display = 'block';
        loader.style.display = 'none';

        getDataButton.disabled = false;
        getDataButtonMobile.disabled = false;
        this.busy = false;
    }

    showAnimation() {
        this.busy = true;

        const getDataButton = this.shadowRoot?.getElementById('getDataButton') as HTMLButtonElement;
        const getDataButtonMobile = this.shadowRoot?.getElementById('getDataButtonMobile') as HTMLButtonElement;
        const dataContainer = this.shadowRoot?.getElementById('dataContainer') as HTMLElement;
        const loader = this.shadowRoot?.getElementById('loader') as HTMLElement;
        const loaderMargin = this.shadowRoot?.getElementById('loader-margin') as HTMLElement;

        getDataButton.disabled = true;
        getDataButtonMobile.disabled = true;

        loaderMargin.style.marginBottom = '200px';
        dataContainer.style.display = 'none';
        loader.style.display = 'block';
    }

    missingRequiredSelections(selectedDimensions: string[]): boolean {
        const accordionStatus = this.accordionStatus;
        for (let index in accordionStatus) {
            if (Object.prototype.hasOwnProperty.call(accordionStatus, index)) {
                this.accordionStatus[index].error = false;
            }
        }

        this.missingFields = this.findMissingFields(selectedDimensions);

        if (this.selectedSubmeasures.length === 0) {
            accordionStatus[0].error = true;
        }
        if (this.selectedAreas.length === 0) {
            accordionStatus[1].error = true;
        }
        if (this.selectedPeriods.length === 0) {
            accordionStatus[2].error = true;
        }
        this.requestUpdate();


        if (this.missingFields.length) {
            this.missingFields.forEach(missingField => {
                const index = this.accordionStatus.findIndex(accordion => accordion.title === missingField);
                this.accordionStatus[index].error = true;
            });
            return true;
        } else {
            return false;
        }
    }

    findMissingFields(selectedDimensions: string[]) {
        let returnFields: string[] = [];
        const requiredDimensions =
            this.metadataMaaling?.maalingHierarchiesContainer?.filter(
                maalingHierarch => maalingHierarch.required && maalingHierarch.dimensionId !== '_omrade') ?? [];

        // Check if all required dimensions have selections
        const selectionInRequiredDimensions =
            requiredDimensions.map(a => a.hierarchyId ? selectedDimensions.includes(a.hierarchyId) : false);

        if (this.selectedSubmeasures.length === 0 && this.accordionStatus[0].title) {
            returnFields.push(this.accordionStatus[0].title);
        }
        if (this.selectedAreas.length === 0 && this.accordionStatus[1].title) {
            returnFields.push(this.accordionStatus[1].title);
        }
        if (this.selectedPeriods.length === 0 && this.accordionStatus[2].title) {
            returnFields.push(this.accordionStatus[2].title);
        }

        if (selectionInRequiredDimensions) {
            // get display names of required dimensions without selections
            const missingSelectedDimensions = [...selectionInRequiredDimensions.keys()]
                .filter(i => !selectionInRequiredDimensions[i])
                .map(a => requiredDimensions[a]).map(a => a.displayName?.toLowerCase());
            if (missingSelectedDimensions.length > 0) {
                returnFields =
                    returnFields.concat(missingSelectedDimensions.map(a => `Vælg ${a}`));
            }
        }

        return returnFields;
    }

    getData(dimensionSelections: string[]) {
        this.dimensionCount = [];
        const dims: any = {};
        for (let i = 0; i < dimensionSelections.length && i < 9; i++) {
            const fieldName = dimensionSelections[i];
            const selectedDimension = this.dimensionSelectMap.get(fieldName);
            if (selectedDimension) {
                const dimObject: { [key: string]: string[] } = {};
                let allMember = true;

                function getSelectedDimensions(option: DimensionOption) {
                    if (option.selected) {
                        if (!dimObject[fieldName]) {
                            dimObject[fieldName] = [];
                        }
                        dimObject[fieldName] = dimObject[fieldName].concat(option.name.trim());
                    } else if (allMember && !option.selected) {
                        allMember = false;
                    }

                    if (!option.children) {
                        return;
                    }

                    option.children.forEach(child => getSelectedDimensions(child));
                }

                selectedDimension.forEach(dimension => getSelectedDimensions(dimension));
                this.dimensionCount.push(dimObject[fieldName].length);

                if (allMember) {
                    dimObject[fieldName] = ['<ALLMEMBERS>'];
                }

                dims[`dim${i + 1}`] = JSON.stringify(dimObject);
            }
        }

        if (this.hierarchiesNonSelectable.length > 0) {
            for (let i = 0; i < this.hierarchiesNonSelectable.length; i++) {
                const dimObject: { [key: string]: string[] } = {};
                dimObject[this.hierarchiesNonSelectable[i]] = ['<ALLMEMBERS>'];
                dims[`dim${Object.keys(dims).length + 1}`] = JSON.stringify(dimObject);
            }
        }

        var mGroupCount = 0;
        if (this.metadataMaaling && this.metadataMaaling.mGroups) {
            mGroupCount = this.metadataMaaling.mGroups.reduce((a, b) => {
                if (b.mgroupID && this.selectedSubmeasures.includes(b.mgroupID) && b.mgroupCount) {
                    return a + b.mgroupCount;
                } else
                    return a;
            },
                0);
        }

        const dataaccordion =
            (this.shadowRoot?.getElementById('databankaccordion') as HTMLElement |
                (HTMLElement & DimensionAccordionElement) |
                null);


        var constant = mGroupCount * this.selectedAreas.length * this.selectedPeriods.length;
        var cellCount = this.dimensionCount.reduce((prev, next) => prev * next, 1) * constant;

        //// Tjek for mærkelige gemte dimensions komboer. Hvis de er tilstede, så tilføj en 'multiplier' til cellCount

        //const multiplierRules: { dims: string[]; multiplier: number }[] = [
        //    { dims: ['_staakut', '_staud'], multiplier: 108 }
        //    // tilføj flere komboer her
        //]

        //let totalMultiplier = 1;

        //multiplierRules.forEach(rule => {
        //    const match = rule.dims.every(dim => dimensionSelections.includes(dim));
        //    if (match) {
        //        totalMultiplier *= rule.multiplier;
        //    }
        //});

        //cellCount *= totalMultiplier;

        ////debug delete
        //console.log("cellCount estimate", cellCount);
        ////debug delete

        var maxCells = 20000;

        if (cellCount > maxCells) {
            this.dialogTitle = "Rapporten kan ikke vises";
            this.dialogText = "Antallet af celler vil overstige grænsen på " + maxCells.toLocaleString("da-DK");
            this.dialogItems = ["Anslået størrelse på " + cellCount.toLocaleString("da-DK")];
            this.dialogVisible = true;
            if (dataaccordion && 'toggleAccordion' in dataaccordion && dataaccordion.expanded) {
                dataaccordion.toggleAccordion();
            }
        }
        else {
            this.showAnimation();
            this.maalingService.getData(
                {
                    dataParameterObject: {
                        cube: this.maalingId,

                        period: JSON.stringify({
                            period: this.selectedPeriods,
                        }),

                        area: this.getAreaJSONString(),

                        measure: JSON.stringify({
                            measure: this.selectedSubmeasures,
                        }),

                        dimension: dimensionSelections.length > 0
                            ? JSON.stringify({
                                dimension: dimensionSelections,
                            })
                            : null,

                        ...dims,
                    }
                }).then(data => {
                    if (!data.header || !data.data) {
                        this.dialogTitle = "Data ej tilgængelig";
                        this.dialogText = "Der foreligger ingen data for de valgte parametre";
                        this.dialogItems = [];
                        this.dialogVisible = true;
                        if (dataaccordion && 'toggleAccordion' in dataaccordion && dataaccordion.expanded) {
                            dataaccordion.toggleAccordion();
                        }
                        this.hideAnimation()
                    } else {
                        this.renderTable(data);
                        this.showFootnotes();

                        if (dataaccordion && 'toggleAccordion' in dataaccordion && !dataaccordion.expanded) {
                            dataaccordion.toggleAccordion();
                        }
                        this.shadowRoot?.getElementById('databankaccordion')?.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                            inline: 'nearest'
                        });
                    }
                }).catch((e) => {
                    this.dialogTitle = "Der er sket en fejl";
                    this.dialogText = "Data kunne ikke hentes, prøv igen";
                    this.dialogItems = [];
                    this.dialogVisible = true;
                    console.error(e);

                    if (dataaccordion && 'toggleAccordion' in dataaccordion && dataaccordion.expanded) {
                        dataaccordion.toggleAccordion();
                    }
                    this.hideAnimation()
                })
        }
    }

    getAreaJSONString(): string | null {
        return JSON.stringify({
            [this.selectedTab]: this.selectedAreas,
        });
    }

    getLeftOffsetStyleString(widths: number[]): string {
        const leftOffsets = widths.reduce<number[]>((prev, cur) => {
            const prevOffset = prev[prev.length - 1];
            prev.push(prevOffset + cur);
            return prev;
        }, [0]);
        return leftOffsets.reduce(
            (prev, offset, index) => prev + `.pvtRowLabel[rowheadercolumnoffset="${index}"] { left: ${offset - 1}px; }`, '');
    }

    cleanHeaders(headers: string[]): string[] {
        return headers.filter(header => header.includes('HierarchyID') || header.includes('Hierarchy'));
    }

    mapHierarchyToDimensionOption(hierarchy: ElementHierarchiesDto): DimensionOption {
        return {
            id: hierarchy.hrchyId ?? 'ERROR MISSING ID',
            name: hierarchy.name ?? 'Ukendt navn',
            selected: false,
            children: hierarchy.children?.map((child) => this.mapHierarchyToDimensionOption(child)),
        };
    }

    mapHierarchyToAreaTabOption(areaTabs: ElementMaalingHierarchyDto[]): AreaTabOption[] {
        //TODO: Implement dropdown (DimensionSortGroup)

        const res = areaTabs.filter(areaTab => areaTab.dimensionId === '_omrade').map(areaTab => ({
            key: areaTab.hierarchyId as string,
            tabName: areaTab.displayName ?? 'Ukendt navn',
            selected: false,
            options: areaTab.hierarchies?.map((child) => this.mapHierarchyToDimensionOption(child)),
        }));

        if (res[0]) {
            res[0].selected = true;
        }

        return res;

    }

    handlePeriodSelectionUpdated(periods: string[]) {
        this.selectedPeriods = periods;

        this.accordionStatus[2].error = false;
        this.requestUpdate();
    }

    handleSubmeasureSelectionUpdated(measures: string[]) {
        this.selectedSubmeasures = measures;

        this.accordionStatus[0].error = false;
        this.requestUpdate();
    }

    handleAreaSelectionUpdate(updatedAreas: string[]) {
        this.selectedAreas = updatedAreas;

        this.areas?.forEach(area => {
            area.options?.forEach(areaOption => {
                if (updatedAreas.includes(areaOption.name)) {
                    areaOption.selected = true;
                } else {
                    areaOption.selected = false;
                }
            });
        });
        this.accordionStatus[1].error = false;
        this.requestUpdate();
    }

    handleAreaTabSelectionUpdate(ars: AreaTabOption[]) {
        if (this.areas && ars) {
            ars.forEach(tabGroup => {
                this.areas?.find(group => {
                    if (group.key === tabGroup.key) {
                        group.selected = tabGroup.selected;
                        if (tabGroup.selected) {
                            this.selectedTab = tabGroup.key;
                            this.selectedAreas = []; // reset selectedAreas when changing tabs
                        }
                    }
                });
            });
        }
    }

    handleDimensionSelectionUpdate(hierarchy: ElementMaalingHierarchyDto, options: DimensionOption[]) {
        if (options == null && hierarchy.hierarchyId) {
            this.dimensionSelectMap.delete(hierarchy.hierarchyId);
        } else if (hierarchy.hierarchyId) {
            this.dimensionSelectMap.set(hierarchy.hierarchyId, options);
        }

        const index = this.accordionStatus.findIndex(a => a.title === 'Vælg ' + hierarchy.displayName?.toLowerCase());
        if (hierarchy.required) {
            this.accordionStatus[index].error = false;
            const idx = this.missingFields.indexOf(this.accordionStatus[index].title);
            this.missingFields.splice(idx, 1);
            this.requestUpdate();
        }
    }

    handleCalcDone(dataWithCalc: any[], periodSort: any, dimensionSort: any) {
        this.periodDisplaynameAndSort = periodSort;
        this.dimensionSort = dimensionSort;
        this.transformedData = dataWithCalc;
        var transformedDataClone = [...this.transformedData];
        transformedDataClone.shift();
        this.JSONdata = JSON.stringify(transformedDataClone);
        this.tableSorting = this.getSortingsForTable(this.dimensionSort, this.measureMgroupRelationMap);
        this.callPivotUI(dataWithCalc);
        this.showCalcControl();
    }
}